module.exports = __webpack_public_path__ + "img/calendar-check-fill.28c69a38.svg";